<template>
  <div class="page-container">
    <div class="query-title">发货计划调整</div>
    <div class="content table-query">
      <collapse-query2>
        <template slot="content">
          <div class="query-container">
            <el-form
              ref="form"
              :rules="rules"
              :model="conditions"
              inline
              class="form"
              size="mini"
              label-width="100px"
            >
              <el-row>
                <el-col :span="8">
                  <el-form-item label="客户名称" prop="customerName">
                    <wly-input
                      v-model="conditions.customerName"
                      input-type="customer"
                      @enter="handleEnter"
                      @handleSuffixClick="openDialog($event, '客户选择')"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="存货分类">
                    <el-select v-model="conditions.brand" filterable clearable>
                      <el-option
                        v-for="item in selectDataOptions['A0019']"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="计划年度" prop="pyear">
                    <el-date-picker
                      v-model="conditions.pyear"
                      value-format="yyyy"
                      format="yyyy"
                      type="year"
                      placeholder="选择年"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="渠道类型">
                    <el-select v-model="conditions.zqdlx">
                      <el-option
                        v-for="item in selectDataOptions['goodsPlanType']"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="月份">
                    <el-input v-model="conditions.monthly" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-button size="mini" icon="el-icon-refresh-right" @click="reset">重置</el-button>
              <el-button size="mini" icon="el-icon-search" type="primary" @click="queryData()">查询</el-button>
            </el-form>
          </div>
        </template>
      </collapse-query2>
      <div class="table-container">
        <TableCommon title="明细" :custome-config="() => vxeShowCustom('xTable')">
          <template #button>
            <table-button name="apply" tip="调整计划" @click="planChange" />
          </template>
          <vxe-grid
            ref="xTable"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="400"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
          >
            <template #adjustDeliveryNum="{ row }">
              <el-input
                v-model="row['adjustDeliveryNum']"
                placeholder="请输入"
                type="number"
                size="mini"
                @input="updateNum(row)"
              />
            </template>
            <template #adjustReason="{ row }">
              <el-input v-model="row['adjustReason']" placeholder="请输入" size="mini" />
            </template>
          </vxe-grid>
        </TableCommon>
      </div>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <org-select v-if="dialogTitle === '营销中心'" ref="dialogSelect" />

        <client-select v-if="dialogTitle === '客户选择'" ref="dialogSelect" />
        <product-select v-if="dialogTitle === '产品选择'" ref="dialogSelect" />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiMonthPlanChangeTableFindList } from '@/api/applyForGoods/monthly'

const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const OrgSelect = () => import('@/components/dialog/OrgSelect.vue')
const ProductSelect = () => import('@/components/dialog/ProductSelect.vue')

const rules = {
  customerName: [{ required: true, message: '请选择客户名称', trigger: 'change' }],
  pyear: [{ required: true, message: '请选择计划年度', trigger: 'change' }]
}
export default {
  components: {
    ClientSelect,
    OrgSelect,
    ProductSelect
  },
  data() {
    return {
      rules,
      dialogTitle: '客户选择',
      showDialog: false,
      currentRow: {},
      conditions: {
        zyxdy: '',
        saleCenterView: '',
        billCode: '',
        customerName: '',
        partner: '',
        productId: '',
        zqdlx: '',
        monthly: '',
        brand: '',
        productName: '',
        pyear: new Date().getFullYear().toString()
      },
      gridOptions: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'brand', title: '存货分类', width: 120 },
          { field: 'brandName', title: '存货分类描述', width: 120 },
          { field: 'zqdlxTextView', title: '渠道类型', width: 120 },
          { field: 'qdjhl', title: '渠道计划量', width: 120 },
          { field: 'zyxdy', title: '营销单元', width: 120 },
          { field: 'zyxdyName', title: '营销单元名称', width: 120 },
          { field: 'annual', title: '实际年度', width: 80 },
          { field: 'monthly', title: '月份', width: 50 },
          { field: 'deliveryNum', title: '计划量', width: 80 },
          { field: 'approvingNum', title: '发货量(审核中)', width: 120 },
          { field: 'usedNum', title: '发货量(归档)', width: 120 },
          { field: 'remainNum', title: '剩余量', width: 80 },
          {
            field: 'adjustDeliveryNum',
            title: '本次调整量',
            width: 120,
            slots: { default: 'adjustDeliveryNum' }
          },
          { field: 'adjustReason', title: '调整原因', width: 140, slots: { default: 'adjustReason' }},
          { field: 'finalNum', title: '调整后计量', width: 100 }
        ],
        data: []
      },
      selectDataOptions: {}
    }
  },
  created() {
    this.getSelectDictDataOrigin('goodsPlanType')
    this.getSelectDictDataOrigin('A0019')
  },
  methods: {
    planChange() {
      const rows = this.gridOptions.data.filter(v => {
        return !!v.finalNum && v.finalNum !== 0
      })
      const params = this.conditions
      console.log(rows)
      if (rows.length > 0) {
        this.$router.push({
          path: '/wly/to-goods/base-setting/delivery-plan-change-apply',
          query: {
            rows: rows,
            params
          }
        })
      } else {
        this.$message.info('没有检查到调整的计划！')
      }
    },
    async queryData() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.findTabList()
        }
      })
    },
    async findTabList() {
      this.loading = true
      const params = { ...this.conditions }
      try {
        const { data } = await apiMonthPlanChangeTableFindList(params)
        this.gridOptions.data = data
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    },
    reset() {
      this.conditions = {
        zyxdy: '',
        saleCenterView: '',
        billCode: '',
        customerName: '',
        partner: '',
        productId: '',
        zqdlx: '',
        productName: '',
        pyear: new Date().getFullYear().toString()
      }
    },
    // 控件回车
    async handleEnter(e, type, data) {
      // console.log('handleEnter', type, data)
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return

      switch (type) {
        case 'customer':
          this.conditions.partner = data.partner
          this.conditions.customerName = data.customerName
          break
        case 'product':
          this.conditions.productId = data.productCode
          this.conditions.productName = data.productShortName
          break
      }
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()

      if (!data) return

      if (this.dialogTitle === '客户选择') {
        this.conditions.partner = data.partner
        this.conditions.customerName = data.customerName
      } else if (this.dialogTitle === '产品选择') {
        this.conditions.productId = data.productCode
        this.conditions.productName = data.productShortName
      } else {
        this.conditions.zyxdy = data.code
        this.conditions.saleCenterView = data.name
      }
      this.showDialog = false
    },
    openDialog(e, title) {
      e.target.blur()
      this.showDialog = true
      this.dialogTitle = title
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 更新调整后计量
    updateNum(item) {
      const remainNum = item.remainNum ? Number(item.remainNum) : 0
      const adjustDeliveryNum = item.adjustDeliveryNum ? Number(item.adjustDeliveryNum) : 0
      item.finalNum = remainNum + adjustDeliveryNum
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/deliveryPlanChange.vue